/**
 * 推送相关
 */

import * as ACTION from '../constants/types/pushTypes';
import { packageReq } from '../helpers/request';
import pushService from '../helpers/pushstream'


// 获取推送服务器信息
export function getPushServiceInfo() {

	var payload = packageReq('GET_PUSH_SERVICE_INFO', null, null, 'GET');

	return {
		type: ACTION.GET_PUSH_SERVICE_INFO,
		payload
	}
}

/**
 * 开启推送
 * @return {[type]} [description]
 */
export function startPush(server_info) {

	return {
		type: ACTION.START_PUSH
	}

}

/**
 * 结束推送
 * @return {[type]} [description]
 */
export function endPush() {
	return {
		type: ACTION.END_PUSH
	}
}

// 推送当前彩种销售情况
export function setLotterySaleData(liveData) {
	return {
		type: ACTION.LIVE_SALE_INFO,
		result: {
			data: liveData
		}
		
	}
}

// 改变用户余额
export function sysnUserBalance(money){
	return {
		type: ACTION.LIVE_USER_BALANCE,
		money: money
	}
}

// 推送开奖更新method数据部分
export function sysnNewHistoryCode(__method, data){
	let newHistory = {};
	// 循环每个窗口
	_.each(__method.windows, function(__window, key){
		if (__window.history_issue.length == 0) {return true}
		const lottery = _.filter(data, (item, lotteryId) => lotteryId == __window.id)
		if (lottery.length == 0) {return true}
		newHistory[key] = _.isArray(lottery[0]) ? lottery[0][0] : lottery[0];
	})
	// 如果没有有窗口正在显示当前推送的彩种
	if (_.isEmpty(newHistory)) {
		return {type: 'NOTHING_TO_DO_SYSN_ISSUE_CODE'};
	}
	return {
		type: ACTION.LIVE_ISSUE_DATA,
		data: newHistory
	}
}

// 推送开奖，更新左侧数据部分
export function sysnLiveHistoryCode(data){
	return {
		type: ACTION.LIVE_ISSUE_CODE_4_MENU,
		data: data
	}
}

// 同步未读聊天数
export function sysnUnreadChatCount(count){
	return {
		type: ACTION.LIVE_UNREAD_CHAT_COUNT,
		count: count
	}
}

// 同步未读站内信数
export function sysnUnreadNoticeCount(count){
	return {
		type: ACTION.LIVE_UNREAD_NOTICE_COUNT,
		count: count
	}
}